import React, { Component } from 'react';
import Gauge from './Gauge';
import Rating from './Rating';
import './Statistics.css';
import DispatchGraph from "./Dispatch";

export default class Statistics extends Component {
    render() {
        const dispatchTime = Math.round(this.props.avgDispatchTime / 60);
        const preparationTime = Math.round(this.props.avgPreparationTime / 60);
        const drivingTime = Math.round(this.props.avgDrivingTime / 60);

        return (
            <div className="stats">
                <div className="stats-gauges">
                    <Gauge { ...this.props }
                        // Kitchen time gauge
                        label="Cozinha"
                        value={ preparationTime }
                        units="min"
                        maxValueMinutes="30"
                    />
                    <Gauge { ...this.props }
                        // "Preparation" (dispatch) time gauge
                        label="Preparação"
                        value={ dispatchTime }
                        units="min"
                        maxValueMinutes="15"
                    />
                    <Gauge { ...this.props }
                        // Driving time gauge
                        label="Na Rua"
                        value={ drivingTime }
                        units="min"
                        maxValueMinutes="30"
                    />
                    <Gauge { ...this.props }
                        // Total delivery time gauge
                        label="Entrega"
                        // The delivery time should be the sum of the previous values
                        // Even though we have this value from the API (avgDeliveryTime),
                        // we sum them anyways to garantee the values do not round up and avoid showing a wrong summed value
                        value={ preparationTime + dispatchTime + drivingTime }
                        units="min"
                        maxValueMinutes="60"
                    />
                    <DispatchGraph
                        { ...this.props }
                    />
                </div>
                <Rating { ...this.props }
                    className="stats-rating"
                    label="Average Rating"
                />
                {
                    this.props.expectedDeliveryTime ?
                        <div className="expected-delivery-time">
                            <span style={{ fontWeight: 'lighter' }}>Tempo Público: </span>
                            { Math.round(this.props.expectedDeliveryTime) + ' min' }
                        </div> : null
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/Statistics/index.js